export const MOBILE_BREAKPOINT = 900;

export const GRID_CONFIG = {
  // Full width on all devices
  FULL: { xs: 24, sm: 24, md: 24, lg: 24, xl: 24, xxl: 24 },
  
  // Half width on desktop, full width on mobile
  HALF: { xs: 24, sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 },
  
  // Three columns on desktop, full width on mobile
  THIRD: { xs: 24, sm: 24, md: 8, lg: 8, xl: 8, xxl: 8 },
  
  // Standard form field column (often used for guest details)
  FORM_COL: { xs: 22, sm: 22, md: 11, lg: 11, xl: 11, xxl: 11 },
  
  // Quarter width on desktop
  QUARTER: { xs: 24, sm: 24, md: 6, lg: 6, xl: 6, xxl: 6 },
  
  // Sidebar/Main content split (5/17 or similar)
  SIDEBAR: { xs: 22, sm: 22, md: 22, lg: 5, xl: 5 },
  MAIN_CONTENT: { xs: 24, sm: 24, md: 24, lg: 17, xl: 17 },
};
